import { useIsLayoutElementsError } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/LayoutElements/useIsLayoutElementsError";
import { useLayoutElementsLoading } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/LayoutElements/useLayoutElementsLoading";
import { useTopOfPageLayoutElements } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/LayoutElements/useTopOfPageLayoutElements";

export const useIsTopOfPageLayoutElementsLoadedAndHasNoResults =
  (): boolean => {
    const isLoading = useLayoutElementsLoading();
    const isError = useIsLayoutElementsError();
    const topOfPageLayoutElements = useTopOfPageLayoutElements();

    if (isLoading) {
      return false;
    }

    if (isError) {
      return true;
    }

    return topOfPageLayoutElements.length === 0;
  };
